module.exports = __webpack_public_path__ + "img/shishikeliu.e7bba91c.png";